import axios from "axios";
import router from "../router";

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL || "http://localhost:5000",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // Handle 401 Unauthorized error (token expired)
      if (error.response.status === 403) {
        // Clear local storage
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("creator");

        // Redirect to login page
        router.push("/login");
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
